import { createToken } from '@/shared/di';
import type { SerpDependencies } from './types';

/**
 * Токены SERP живут здесь, а не в `shared/di/tokens.ts`: они типизированы сущностями
 * (`ProductSearch`, `UseSearchCriteria`), а `shared` не имеет права импортировать `entities`.
 */
export const SERP_SEARCH_CRITERIA_TOKEN = createToken<SerpDependencies['useSearchCriteria']>('serp/useSearchCriteria');
export const SERP_PRODUCT_SEARCH_TOKEN = createToken<SerpDependencies['productSearch']>('serp/productSearch');
